import React from 'react';

export const ChevronDownGray400Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_6678_25392"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="6"
        width="12"
        height="8"
      >
        <path
          d="M9.41668 13.0833L4.41668 8.08329C4.25001 7.91663 4.16668 7.74996 4.16668 7.49996C4.16668 7.24996 4.25001 7.08329 4.41668 6.91663C4.75001 6.58329 5.25001 6.58329 5.58334 6.91663L10 11.3333L14.4167 6.91663C14.75 6.58329 15.25 6.58329 15.5833 6.91663C15.9167 7.24996 15.9167 7.74996 15.5833 8.08329L10.5833 13.0833C10.25 13.4166 9.75001 13.4166 9.41668 13.0833Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_6678_25392)">
        <rect width="20" height="20" transform="translate(20) rotate(90)" fill="#888888" />
      </g>
    </svg>
  );
};
